<script setup lang="ts">
import { computed, shallowRef, watchEffect } from 'vue'
import { StepperIndicator, useForwardProps } from 'radix-vue'
import type { IStepperIndicatorProps } from '../types'
import { useStepperIndicatorConfig } from './composables/useStepperIndicatorConfig'

const props = defineProps<IStepperIndicatorProps>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwarded = useForwardProps(delegatedProps)

const stepperSeperatorConfig = shallowRef(useStepperIndicatorConfig(props))

watchEffect(() => {
    stepperSeperatorConfig.value = useStepperIndicatorConfig(props)
})
</script>

<template>
    <StepperIndicator
        v-bind="forwarded"
        :class="[stepperSeperatorConfig.root, props.class]"
    >
        <slot />
    </StepperIndicator>
</template>
